import React from "react";

import OrderBottomBar from "../../../../shared/OrderBottomBar";
import useCheckoutStore from "../store";

const BottomBar = () => {
    const [prices] = useCheckoutStore((state) => [state.getPrices()]);

    if (!prices) {
        return null;
    }

    return (
        <OrderBottomBar
            price={`${prices.priceGross} €`}
            leftText="Preis 100l inkl. MwSt."
            totalPrice={`${
                prices.priceTotalWithAction !== null
                    ? prices.priceTotalWithAction
                    : prices.priceTotalGross
            } €`}
        />
    );
};

export default BottomBar;
